import { useLayoutContext } from './layout-context';

export const HideInEmbedded = ({ children }: { children: React.ReactNode }) => {
  const { isEmbeddedMode } = useLayoutContext();
  return isEmbeddedMode ? null : children;
};
